import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './auth/Login';
import Register from './auth/Register';
import NavBar from './NavBar';
import SessionTimeoutModal from './auth/SessionTimeoutModal';

// Importa tus componentes de la aplicación
import AppPortal from './apps/portal';

// Puedes importar tus otros componentes aquí
// import SeismicCalc from './apps/seismic-calc';

const AppRouter = () => {
  return (
    <Router>
      <AuthProvider>
        <NavBar />
        <SessionTimeoutModal />
        <Routes>
          {/* Rutas de autenticación */}
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Register />} />
          
          {/* Rutas protegidas */}
          <Route
             path="/portal"
             element={
              <ProtectedRoute>
                <AppPortal />
              </ProtectedRoute>
            }
           />
          
          {/* Añade rutas para tus otras aplicaciones aquí */}
          {/* <Route
             path="/seismic-calc/*"
             element={
              <ProtectedRoute>
                <SeismicCalc />
              </ProtectedRoute>
            }
           /> */}
          
          {/* Redirección por defecto */}
          <Route path="/" element={<Navigate to="/portal" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default AppRouter;